import type { NavItem, Stat, Integration } from '@/types/content';

export const mainNavigation: NavItem[] = [
  {
    label: 'Features',
    href: '/features',
    children: [
      { label: 'Smart Dispatch', href: '/features#scheduling' },
      { label: 'Route Intelligence', href: '/features#routes' },
      { label: 'VoIP & AI Receptionist', href: '/features#voip' },
      { label: 'CRM & Pipelines', href: '/features#crm' },
      { label: 'Job Profitability', href: '/features#profitability' },
      { label: 'Business Rhythm', href: '/features#business-rhythm' },
      { label: 'View All Features', href: '/features' },
    ],
  },
  {
    label: 'Industries',
    href: '#',
    children: [
      { label: 'HVAC', href: '/industries/hvac' },
      { label: 'Plumbing', href: '/industries/plumbing' },
      { label: 'Electrical', href: '/industries/electrical' },
      { label: 'Garage Doors', href: '/industries/garage-doors' },
      { label: 'Landscaping', href: '/industries/landscaping' },
      { label: 'Pest Control', href: '/industries/pest-control' },
      { label: 'Roofing', href: '/industries/roofing' },
      { label: 'Cleaning Services', href: '/industries/carpet-cleaning' },
      { label: 'Pool & Spa', href: '/industries/pool-service' },
      { label: 'Appliance Repair', href: '/industries/appliance-repair' },
    ],
  },
  {
    label: 'Resources',
    href: '/resources',
    children: [
      { label: 'All Resources', href: '/resources' },
      { label: 'Blog', href: '/blog' },
      { label: 'Case Studies', href: '/resources#case-studies' },
      { label: 'Guides & eBooks', href: '/resources#guides' },
      { label: 'Webinars', href: '/resources#webinars' },
    ],
  },
  {
    label: 'Pricing',
    href: '/pricing',
  },
  {
    label: 'About',
    href: '/about',
  },
];

export const footerNavigation = {
  product: [
    { label: 'Features', href: '/features' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Integrations', href: '/features#integrations' },
    { label: 'Mobile App', href: '/features#mobile' },
  ],
  industries: [
    // Core Trades
    { label: 'HVAC', href: '/industries/hvac' },
    { label: 'Plumbing', href: '/industries/plumbing' },
    { label: 'Electrical', href: '/industries/electrical' },
    { label: 'Roofing', href: '/industries/roofing' },
    // Property Services
    { label: 'Landscaping', href: '/industries/landscaping' },
    { label: 'Lawn Care', href: '/industries/lawn-care' },
    { label: 'Tree Service', href: '/industries/tree-service' },
    // Cleaning & Maintenance
    { label: 'Window Cleaning', href: '/industries/window-cleaning' },
    { label: 'Pressure Washing', href: '/industries/pressure-washing' },
    { label: 'Carpet Cleaning', href: '/industries/carpet-cleaning' },
    // Specialty Trades
    { label: 'Garage Doors', href: '/industries/garage-doors' },
    { label: 'Painting', href: '/industries/painting' },
    // Home Services
    { label: 'Pest Control', href: '/industries/pest-control' },
    { label: 'Pool Service', href: '/industries/pool-service' },
    { label: 'Appliance Repair', href: '/industries/appliance-repair' },
    { label: 'Handyman', href: '/industries/handyman' },
  ],
  company: [
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
    { label: 'Careers', href: '/careers' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
  ],
  resources: [
    { label: 'All Resources', href: '/resources' },
    { label: 'Blog', href: '/blog' },
    { label: 'Case Studies', href: '/resources#case-studies' },
    { label: 'Guides & eBooks', href: '/resources#guides' },
    { label: 'Webinars', href: '/resources#webinars' },
    { label: 'Help Center', href: '/help' },
    { label: 'API Docs', href: '/api' },
  ],
  compare: [
    { label: 'Compare All', href: '/compare' },
    { label: 'vs ServiceTitan', href: '/vs/servicetitan' },
    { label: 'vs Jobber', href: '/vs/jobber' },
    { label: 'vs Housecall Pro', href: '/vs/housecall-pro' },
    { label: 'vs FieldEdge', href: '/vs/fieldedge' },
    { label: 'vs Service Fusion', href: '/vs/service-fusion' },
    { label: 'vs simPRO', href: '/vs/simpro' },
  ],
};

export const companyStats: Stat[] = [
  { value: '500', label: 'Service Companies', suffix: '+' },
  { value: '10', label: 'Jobs Completed', suffix: 'M+' },
  { value: '50', label: 'Admin Time Saved', suffix: '%' },
  { value: '99.9', label: 'Uptime', suffix: '%' },
];

export const integrations: Integration[] = [
  // Accounting
  { id: 'quickbooks', name: 'QuickBooks Online', logoUrl: '/images/integrations/quickbooks.svg', category: 'accounting' },
  { id: 'xero', name: 'Xero', logoUrl: '/images/integrations/xero.svg', category: 'accounting' },
  // Payments
  { id: 'stripe', name: 'Stripe', logoUrl: '/images/integrations/stripe.svg', category: 'payments' },
  { id: 'square', name: 'Square', logoUrl: '/images/integrations/square.svg', category: 'payments' },
  { id: 'paypal', name: 'PayPal', logoUrl: '/images/integrations/paypal.svg', category: 'payments' },
  // Calendar
  { id: 'google-calendar', name: 'Google Calendar', logoUrl: '/images/integrations/google-calendar.svg', category: 'calendar' },
  { id: 'outlook', name: 'Outlook', logoUrl: '/images/integrations/outlook.svg', category: 'calendar' },
  // Communication
  { id: 'twilio', name: 'Twilio', logoUrl: '/images/integrations/twilio.svg', category: 'communication' },
  { id: 'sendgrid', name: 'SendGrid', logoUrl: '/images/integrations/sendgrid.svg', category: 'communication' },
  // Other
  { id: 'zapier', name: 'Zapier', logoUrl: '/images/integrations/zapier.svg', category: 'other' },
  { id: 'google-maps', name: 'Google Maps', logoUrl: '/images/integrations/google-maps.svg', category: 'other' },
  { id: 'salesforce', name: 'Salesforce', logoUrl: '/images/integrations/salesforce.svg', category: 'other' },
];
